import React from 'react'

const DotIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='7'
    height='7'
    viewBox='0 0 5 5'
    fill='currentColor'
    {...props}
  >
    <circle cx='2.5' cy='2.5' r='2.5' fill='currentcolor' />
  </svg>
)

export default DotIcon
